import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getAssignmentAuditLogs = async (params = {}) => {
  try {
    const response = await apiClient.get('/systemInvoiceRoleManagement/audit-logs', { params });
    return response?.data?.response || response?.data?.data || [];
  } catch (error) {
    handleApiError(error);
    return [];
  }
};
